import 'babel-polyfill';
import './polyfill/polyfill';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import './i18n/axiosLanguageInterceptor';
import i18n from './i18n/i18n';
import store from './store/index';
import LogClient from './components/LogClient';
import './authentication/services/tokenInterceptor';
import './transformers/transformers';

router.beforeEach(function(to, from, next) {
    window.scrollTo(0, 0);
    next();
});

Vue.config.errorHandler = function(error, vm, info) {
    LogClient.sendLogToServer(error.toString(), info);
    console.error(`Error: ${error}, infos: ${info}, vm: ${vm}`);
};

window.onerror = function(messageOrEvent, source, lineno, colno, error) {
    LogClient.sendLogToServer(messageOrEvent, { source: source, lineno: lineno, colno: colno, error: error });
};

const app = new Vue({
    el: '#app-main',
    router: router,
    store: store,
    render: h => h(App),
    i18n: i18n
});

window.app = app;
